export default "__VITE_ASSET__CPTWFouA__"